<!-- 用户管理 -->
<template>
	<treeBody>
		<userManageUnitTree slot="tree" class='hideBar' @checkItem='checkItem' :fllowCache='true'>
			
		</userManageUnitTree>
		<div slot="body">
			<div class="buttonLine">
				<iconButton icoName="wedoButton/add_user.png" buttonText="添加用户" @buttonClick="addNewUser"></iconButton>
				<iconButton icoName="wedoButton/edit.png" buttonText="修改用户" @buttonClick="updateUserInfo"></iconButton>
				<iconButton v-show="userSelected.id != undefined && userSelected.id != userId" icoName="wedoButton/delete_user.png" buttonText="删除用户" @buttonClick="deleteUser"></iconButton>
			</div>
			<div class="viewEditUsers custom-scrollbar">
				<div class="areaContainer">
					<div class="areaTitle">用户/角色</div>
					<div class="usersInfoRole">
						<div class="usersInfoList">
							<infoList ref="userInfoList" style="height: 301px;" :columns='columns' :dataList="nowPage" :pageLen='pageLen' :totalSize="nowUnitUserList.length" :checkedFirst="true" @selectPage="nowIndex = $event" :fillAll="true" @clickTableBody="selectUser" @clickTableHead="clickTableHead"></infoList>
						</div>
						<div class="rolesList">
							<roleList ref="roleView" :nowCheckedIds="userSelectedRoles" :functionType="0"></roleList>
						</div>
					</div>
				</div>
				<div class="areaContainer">
					<div class="areaTitle">权限配置</div>
					<div class="tabsHeader">
						<div class="tabBtnsContainer">
							<button :class="{'tabActive':tabPage == 0}" @click="tabPageChange(0)">用户权限</button>
							<button :class="{'tabActive':tabPage == 1}" @click="tabPageChange(1)">设备权限</button>
						</div>
						<button class="saveEditBtn" @click="saveEdit">保存</button>
					</div>
					<!-- 用户权限（系统权限、web权限、App权限） -->
					<userRight ref="userRightView" v-show="tabPage == 0"></userRight>
					<!-- 设备权限 （查看设备权限、可操作设备权限）-->
					<userDevice ref="userDeviceView" v-show="tabPage == 1"></userDevice>
				</div>
			</div>
			<!-- 添加用户填写基础信息，选择角色弹窗 -->
			<addNewUserDialog ref="addNewUserDialog"></addNewUserDialog>
			<!-- 新增用户选择设备权限弹窗 -->
			<deviceSelectDialog ref="deviceSelectDialog"></deviceSelectDialog>
			<!-- 新增用户选择用户权限弹窗 -->
			<rightSelectDialog ref="rightSelectDialog"></rightSelectDialog>
			<!-- 修改用户 -->
			<updateUserInfoDialog ref="updateUserInfoDialog" @updateUserInfoSuccess="updateUserInfoEmit"></updateUserInfoDialog>
		</div>
	</treeBody>
</template>

<script type="text/javascript">
	import iconButton from '@/components/module/universal/iconButton.vue'
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import userManageUnitTree from '@/components/module/tree/userMangeUnitTree.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import userRight from '@/page/userManager/userRight.vue'
	import userDevice from '@/page/userManager/userDevice.vue'
	import addNewUserDialog from '@/page/userManager/addNewUserDialog.vue'
	import deviceSelectDialog from '@/page/userManager/deviceSelectDialog.vue'
	import rightSelectDialog from '@/page/userManager/rightSelectDialog.vue'
	import updateUserInfoDialog from '@/page/userManager/updateUserInfoDialog.vue'
	import roleList from '@/page/userManager/roleList.vue'
	import userManagerStore from '@/page/userManager/userManagerStore.js'
	export default {
		components: {
			iconButton,
			treeBody,
			dialogBody,
			userManageUnitTree,
			infoList,
			userRight,
			userDevice,
			addNewUserDialog,
			deviceSelectDialog,
			rightSelectDialog,
			updateUserInfoDialog,
			roleList
		},
		props: [],
		data() {
			return {
				tabPage: 0,
				nowIndex: 0,
				newUserData: undefined,  // 新建用户信息对象
				newUserRoleIds: undefined,  // 新建用户的角色ids
				newUserDeviceNos: undefined,  // 新加用户选中的设备ids
				newUserRolesRights: undefined, // 新建用户选择角色的权限
				newUserRightIds: undefined,  // 新建用户的权限字符串ids
				addUserResponDatas: []
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			userId() {
				var userInfo = this.$store.userStore.state.nowUserInfo
				return userInfo.userId
			},
			columns() {
				return [{name:'用户名称', key:'username', weight:1},{name:'登录名', key:'usercode', weight:1},{name:'卡号', key:'rfid', weight:1.5},{name:'邮箱地址', key:'emailaddress', weight:2},{name:'手机号', key:'mobile', weight:1.5},{name:'座机号码', key:'telephone', weight:1},{name:'备注', key:'memo', weight:3}]
			},
			pageLen() {
				return this.nowUnitUserList.length < 20 ? this.nowUnitUserList.length : 20
			},
			nowPage() {
				// 按照页码来返回当前应该显示的列表
				var list = this.nowUnitUserList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				return list
			},
			allRightList() {
				 
				return userManagerStore.state.allRightList
			},
			nowUnitUserList() {
				return userManagerStore.state.userList
			},
			userSelectedRoles() {
				return userManagerStore.state.nowUserRoleIds
			},
			nowCheckedUnit() {
				return userManagerStore.state.nowUnit
			},
			userSelected() {
				return userManagerStore.state.nowUser
			}
		},
		watch: {
			addUserResponDatas() {
				if(this.addUserResponDatas.length >= 3){
					var result = this.addUserResponDatas.filter(item => {
						return !item.status
					})
					if(result.length > 0){
						var message = []
						for(let i = 0;i < result.length;i++){
							message.push(result[i].message)
						}
						this.$dialogMethod.showMessage(message.join(','))
					}else{
						this.$dialogMethod.showMessage('添加用户成功')
					}
					this.addUserResponDatas = []
				}
			},
		},
		methods: {
			// 分页切换
			tabPageChange(i){
				if(this.tabPage == i){
					return
				}
				if(i == 0){
					// if(this.$refs.userDeviceView.editNeedSave || this.$refs.userDeviceView.viewNeedSave){
					// 	// this.$dialogMethod.openAgreeDialog("有修改尚未保存", "是否进行保存后再离开", confirm => {
					// 	// 	return
					// 	// }, cancel => {
					// 	// 	this.tabPage = i
					// 	// 	this.$refs.userDeviceView.resetDatas()
					// 	// }, true)
					// 	 this.$confirm('有修改尚未保存, 是否进行保存后再离开?', '提示', {
					// 			confirmButtonText: '确定',
					// 			cancelButtonText: '取消',
					// 			type: 'warning'
					// 			}).then(() => {
					// 				this.saveEdit()
					// 				 this.tabPage = i
					// 				// this.$message({
					// 				// 	type: 'success',
					// 				// 	message: '保存!'
					// 				// });
					// 			}).catch(() => {
					// 				this.$message({
					// 					type: 'info',
					// 					message: '已取消保存'
					// 				});  
					// 				this.tabPage = i    
					// 				this.$refs.userDeviceView.resetDatas()    
					// 			});
					// }else{
						this.tabPage = i
						this.$refs.userDeviceView.resetDatas()
					// }
				}else{
					// if(this.$refs.userRightView.needSave){
					// 	// 弹窗确认是否进行保存
					// 	// this.$dialogMethod.openAgreeDialog("有修改尚未保存", "是否进行保存后再离开", confirm => {
					// 	// 	console.log("寄哪里");
					// 	// 	return
					// 	// }, cancel => {
					// 	// 	this.tabPage = i
					// 	// 	this.$refs.userRightView.coverCheckedIds()
					// 	// }, true)
					// 	 this.$confirm('有修改尚未保存, 是否进行保存后再离开?', '提示', {
					// 			confirmButtonText: '确定',
					// 			cancelButtonText: '取消',
					// 			type: 'warning'
					// 			}).then(() => {
					// 				this.saveEdit()
					// 				 this.tabPage = i
					// 				// this.$message({
					// 				// 	type: 'success',
					// 				// 	message: '保存!'
					// 				// });
					// 			}).catch(() => {
					// 				this.$message({
					// 					type: 'info',
					// 					message: '已取消保存'
					// 				});  
					// 				this.tabPage = i    
					// 				this.$refs.userRightView.coverCheckedIds()    
					// 			});
					// }else{
						this.tabPage = i
						this.$refs.userRightView.coverCheckedIds()
					// }
				}
			},
			// 选中公司事件
			checkItem(item) {
				if(this.nowCheckedUnit.id == undefined || this.nowCheckedUnit.id != item.id){
					userManagerStore.commit('setUnit', item)
				}
			},
			// 选中用户事件
			selectUser(item) {
				if(item == undefined){
					userManagerStore.commit('setUser', {})
				}else if(this.userSelected.id == undefined || this.userSelected.id != item.id){
					userManagerStore.commit('setUser', item)
				}
			},
			clickTableHead() {
				userManagerStore.commit('setUser', {})
			},
			// 根据角色获取绑定的权限
			getRightsByRoleIds() {
				if(isempty(this.newUserRoleIds)){
					this.newUserRolesRights = {pcmDefault:[],appRight:[],menuRight:[]}
					this.openRightSelectDialog()
					return
				}
				this.$api.menuApi.getRightsByRoleIds(this.newUserRoleIds, res => {
					this.newUserRolesRights = res
					this.openRightSelectDialog()
				}, failure => {
					this.$dialogMethod.showMessage(failure)
				})
			},
			// 添加用户
			addNewUser() {
				if(this.nowCheckedUnit == undefined){
					this.$dialogMethod.showMessage('请选择组织后再添加用户')
					return
				}
				this.$refs.addNewUserDialog.open('添加用户', (userData, roleIds)=>{
					this.newUserData = userData
					this.newUserRoleIds = roleIds
					this.$refs.deviceSelectDialog.open('设备权限', respon => {
						this.newUserDeviceNos = respon
						this.getRightsByRoleIds()
					})
				})
			},
			// 打开选择用户权限弹窗
			openRightSelectDialog() {
				this.$refs.rightSelectDialog.open('用户权限', copy(this.newUserRolesRights), respon => {
					this.newUserRightIds = respon
					// 信息填写完毕创建新用户
					if(this.newUserData.emailpsw == '' || this.newUserData.emailpsw == null || !this.newUserData.emailpsw){
						var emailpsw = null
					}else{
						var emailpsw = hex_md5(this.newUserData.emailpsw)
					}
					this.$api.userApi.saveUser('', this.newUserData.username, this.newUserData.usercode, hex_md5(this.newUserData.password), this.newUserData.mobile, this.newUserData.telephone, this.nowCheckedUnit.id, this.newUserData.emailaddress, emailpsw, undefined, undefined, this.newUserData.memo, this.newUserRoleIds, this.newUserData.isSSO, undefined, saveRespon => {
						var newUserId = saveRespon.id
						// 第二步绑定设备权限
						this.bindUserAndDevice('view', newUserId, this.newUserDeviceNos.view)
						this.bindUserAndDevice('edit', newUserId, this.newUserDeviceNos.edit)
						// 第三步绑定用户权限
						this.bindUserAndRight(newUserId, this.newUserRightIds)
						// 获取新的用户列表
						userManagerStore.commit('getUsersByUnitId', this.nowCheckedUnit.id)
					}, err => {
						this.$dialogMethod.showMessage("添加用户失败！")
					})
				})
			},
			// 删除用户
			deleteUser() {
				if(this.userSelected.id == undefined){
					this.$dialogMethod.showMessage('请先选中要删除的用户')
					return
				}
				this.$api.userApi.deleteUserById(this.userSelected.id, res => {
					this.$dialogMethod.showMessage('删除用户信息成功！')
					userManagerStore.commit('getUsersByUnitId', this.nowCheckedUnit.id)
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			},
			// 更新用户信息
			updateUserInfo() {
				if(this.userSelected.id == undefined){
					this.$dialogMethod.showMessage('请先选中要修改信息的用户')
					return
				}
				this.$refs.updateUserInfoDialog.open('修改用户信息', this.userSelected, copy(this.userSelectedRoles))
			},
			updateUserInfoEmit(passwordChange) {
				if(passwordChange && this.userSelected.id == this.userId){
					this.logout()
				}else{
					userManagerStore.commit('getUsersByUnitId', this.nowCheckedUnit.id)
				}
			},
			// 绑定用户与权限
			bindUserAndRight(userId, rightIds) {
				this.$api.userApi.bindUserAndRight(userId, rightIds, res=>{
					this.addUserResponDatas.push({step:3, status:true, message:res})
				}, err => {
					this.addUserResponDatas.push({step:3, status:false, message:err})
				})
			},
			// 绑定用户与设备权限
			bindUserAndDevice(type, userId, deviceNos) {
				this.$api.userApi.bindUserAndDevice(type, userId, deviceNos, res => {
					if(type == 'view'){
						this.addUserResponDatas.push({step:1, status:true, message:res})
					}else if(type == 'edit'){
						this.addUserResponDatas.push({step:2, status:true, message:res})
					}
				}, err => {
					if(type == 'view'){
						this.addUserResponDatas.push({step:1, status:false, message:err})
					}else if(type == 'edit'){
						this.addUserResponDatas.push({step:2, status:false, message:err})
					}
				})
			},
			saveEdit(){
				console.log("点击113");
				if(this.tabPage == 0){
					// 保存用户权限
					// console.log("用户权限");
					this.$refs.userRightView.saveEdit()
				}else if(this.tabPage == 1){
					// console.log("设备权限");
					// 保存设备权限
					this.$refs.userDeviceView.saveEdit()
				}
			},
			logout() {
				this.$store.menuStore.commit('clear')
				this.$dialogMethod.showLoading("正在注销...")
				this.$api.userApi.logout(respon => {
					//清理所有缓存
					toLogin()
				})
			}
		}
	}
</script>

<style scoped>
	.viewEditUsers{
		height: calc(100% - 54px);
		background: #EFF3F9;
		padding: 12px;
		box-sizing: border-box;
	}
	
	.areaContainer{
		background: #FFFFFF;
		padding: 20px;
		margin-bottom: 20px;
	}
	
	.areaContainer:last-child{
		margin-bottom: 0;
	}
	
	.areaTitle{
		font-size: .14rem;
		font-weight: 600;
		line-height: 16px;
		border-left: solid 4px #3D7EFF;
		padding-left: 8px;
		margin-bottom: 8px;
	}
	
	.usersInfoRole{
		overflow: hidden;
	}
	
	.tabsHeader{
		margin-bottom: 12px;
		overflow: hidden;
	}
	
	.tabBtnsContainer{
		float: left;
		border: solid 2px #D1D1D1;
		border-radius: 16px;
	}
	
	.tabBtnsContainer>button{
		cursor: pointer;
		width: 100px;
		height: 30px;
		border-radius: 15px;
		background: #FFFFFF;
		color: #3D7EFF;
		outline: none;
	}
	
	.tabBtnsContainer>.tabActive{
		background: #3D7EFF;
		color: #FFFFFF;
		width: 110px;
	}
	
	.saveEditBtn{
		float: right;
		width: 110px;
		height: 32px;
		background: #3D7EFF;
		color: #FFFFFF;
		border-radius: 16px;
		margin-top: 1px;
		outline: none;
	}
	
	.usersInfoList{
		float: left;
		width: calc(100% - 252px);
	}
	
	.trActive{
		background: #5979C9;
	}
	
	.rolesList{
		float: right;
		width: 240px;
	}
	
	.rolesList input{
		vertical-align: middle;
		margin-right: 2px;
	}
</style>